<template>
  <highlightjs language='cpp' :code="codeText" />
</template>

<style>
@import '../../node_modules/highlight.js/styles/github-gist.css';

code.hljs {
  display: block;
  margin: 1em;
  padding: 1em;
}
</style>

<script>
import Vue from 'vue'
import hljs from '@/common/my-highlight.js'

Vue.use(hljs.vuePlugin)

export default {
  props: ['codeText'], 
};
</script>


